import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { PropsWithChildren } from "react";
import { MobileNavBar } from "@/components/mobile/NavBar";
import { Link } from "react-router-dom";
import { RegisteredUsersBanner } from "@/components/RegisteredUsersBanner";
import { ErrorBoundaryPage } from "@/components/errors/ErrorBoundaryPage";
import { useLocation } from "react-router-dom";
import {
  isMarketplacePath,
  marketplaceArea,
} from "@/utils/marketplaceNavigation";
import {
  MarketplaceNavigation,
  SellerWorkspaceNavigation,
} from "@/components/marketplace/MarketplaceNavigation";

export function MainLayout({ children }: PropsWithChildren) {
  const { pathname } = useLocation();
  const marketplace = isMarketplacePath(pathname);
  return (
    <div
      className={`min-h-screen pb-[calc(80px+env(safe-area-inset-bottom))] lg:pb-0 ${marketplace ? "marketplace-shell bg-[#faf9f6] dark:bg-[#020817]" : "bg-[#f9fafb] dark:bg-[#020817]"}`}
    >
      <Header />
      {marketplace && marketplaceArea(pathname) !== "seller" && <MarketplaceNavigation />}
      {marketplace && marketplaceArea(pathname) === "seller" && (
        <SellerWorkspaceNavigation />
      )}
      {!marketplace && (
        <div className="lg:block hidden">
          <RegisteredUsersBanner />
        </div>
      )}
      <div>
        <ErrorBoundaryPage>{children}</ErrorBoundaryPage>
      </div>
      {marketplace ? (
        <footer className="container max-w-7xl border-t py-6 text-xs text-muted-foreground">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p>PokeLlama · From one collector to another</p>
            <Link className="inline-flex min-h-11 items-center underline" to="/plans">Plans & billing</Link>
            <Link className="underline" to="/faq">
              Help & frequently asked questions
            </Link>
          </div>
        </footer>
      ) : (
        <Footer />
      )}
      <MobileNavBar />
      {/* <PwaUpdateBanner /> */}
    </div>
  );
}


